export default function Phase4() {
  return (
    <section className="bg-white py-16 md:py-24">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        {/* Phase Header */}
        <div className="flex items-center justify-center mb-8">
          <img 
            src="https://kajabi-storefronts-production.kajabi-cdn.com/kajabi-storefronts-production/file-uploads/themes/2160517458/settings_images/c821fd2-60ad-dfbb-b7b-3c7076dbb748_0a9554db-dfc8-42b5-bbf2-fe0e7fe8eafe.png" 
            alt="Phase Icon" 
            className="w-16 h-16"
          />
        </div>

        <div className="max-w-4xl mx-auto text-left mb-12">
          <h4 className="text-xl font-bold text-gray-900 mb-2">
            <span>Phase 4:</span>
          </h4>
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900">
            <span>AI Thumbnail Engineer</span>
          </h2>
        </div>

        {/* Video */}
        <div className="max-w-5xl mx-auto mb-12">
          <div 
            className="relative w-full overflow-hidden rounded-lg" 
            style={{ 
              paddingBottom: '56.25%',
              touchAction: 'pan-y',
              WebkitOverflowScrolling: 'touch'
            }}
          >
            <iframe 
              src="https://player.mediadelivery.net/embed/555127/8198feb1-5124-4f09-a7d6-3feddccb09bc?autoplay=true&loop=true&muted=true&playsinline=true" 
              title="AI Thumbnail Engineer Video" 
              allow="autoplay; fullscreen" 
              allowFullScreen
              className="absolute top-0 left-0 w-full h-full rounded-lg"
              style={{ 
                border: 'none',
                pointerEvents: 'auto',
                maxWidth: '100%',
                maxHeight: '100%'
              }}
              loading="lazy"
            ></iframe>
          </div>
        </div>

        {/* Content */}
        <div className="max-w-4xl mx-auto mb-12">
          <div className="bg-white rounded-lg shadow-md p-8">
            <p className="text-base text-gray-700 mb-4">To succeed as a content creator, <strong>you need good thumbnails</strong>.</p>
            <p className="text-base text-gray-700 mb-4">Even if you made an incredible video...</p>
            <p className="text-base text-gray-700 mb-4"><span>Without a good thumbnail, your video will never get clicked and never get viewed.</span></p>
            <p className="text-base text-gray-700 mb-4">Traditionally, to create a good thumbnail, you'd need an expensive camera, lens, and professional lighting setup.</p>
            <p className="text-base text-gray-700 mb-4">And that's just to take the PHOTO!</p>
            <p className="text-base text-gray-700 mb-4">After that, you'd need to learn the expensive software yourself to add the color grade, the graphics, and any other elements to make it pop</p>
            <p className="text-base text-gray-700">Or... you'd have to hire a professional graphic designer to do that for you, which usually costs between $100-$400</p>
          </div>
        </div>

        <div className="max-w-4xl mx-auto text-center mb-12">
          <h4 className="text-2xl font-bold text-gray-900 mb-2">
            <span>With AI, you can avoid all of this.</span>
          </h4>
          <h4 className="text-2xl font-bold text-gray-900">
            <span>Create Spectacular Thumbnails in seconds!</span>
          </h4>
        </div>

        {/* Thumbnail Examples */}
        <div className="grid md:grid-cols-2 gap-8 mb-12">
          <img 
            src="https://static.readdy.ai/image/1ee33a74a7d817227244af36e3fd2b0e/2255c643783f701cf1b3e894f1569c2a.jpeg" 
            alt="AI Thumbnail" 
            className="w-full rounded-lg"
          />
          <img 
            src="https://static.readdy.ai/image/1ee33a74a7d817227244af36e3fd2b0e/4e4aa15a1b7cb2234b0b3e5cbbeaf0db.jpeg" 
            alt="AI Thumbnail" 
            className="w-full rounded-lg"
          />
          <img 
            src="https://static.readdy.ai/image/1ee33a74a7d817227244af36e3fd2b0e/6854d81803f73e54c4158b1162264779.jpeg" 
            alt="AI Thumbnail" 
            className="w-full rounded-lg"
          />
          <img 
            src="https://static.readdy.ai/image/1ee33a74a7d817227244af36e3fd2b0e/f4f015885824e95df5353a2f7f74c872.jpeg" 
            alt="AI Thumbnail" 
            className="w-full rounded-lg"
          />
          <img 
            src="https://static.readdy.ai/image/1ee33a74a7d817227244af36e3fd2b0e/cf89b9389f2d5c9a7197ab7f5dfcb36c.jpeg" 
            alt="AI Thumbnail" 
            className="w-full rounded-lg"
          />
          <img 
            src="https://kajabi-storefronts-production.kajabi-cdn.com/kajabi-storefronts-production/file-uploads/themes/2160737798/settings_images/3bfb8dd-d262-d2f3-dac5-0f128ac43661_Capcut_tutorial.png" 
            alt="AI Thumbnail" 
            className="w-full rounded-lg"
          />
        </div>

        {/* Explanation */}
        <div className="max-w-4xl mx-auto mb-12">
          <div className="bg-white rounded-lg shadow-md p-8">
            <p className="text-base text-gray-700 mb-4">Look closely at the AI generated thumbnails above</p>
            <p className="text-base text-gray-700 mb-4">Most of these would have been absolutely impossible to create without AI</p>
            <p className="text-base text-gray-700 mb-4">There's no way I'd ever get in the water with a great white shark...</p>
            <p className="text-base text-gray-700 mb-4">I don't own any medieval knight armor or a sword (I wish I did 😂)</p>
            <p className="text-base text-gray-700 mb-4">Even the thumbnail showing "economy vs first class flights"</p>
            <p className="text-base text-gray-700 mb-4">To create that manually, I would need to purchase both an economy and first class flight ticket (thousands of dollars) and THEN I would have also needed to take out my professional cameras in front of all the other passengers and pose like an influencer for 10-30 photos.</p>
            <p className="text-base text-gray-700 mb-4"><strong>I DO NOT WANT TO DO THAT.</strong></p>
            <p className="text-base text-gray-700 mb-4">AI is revolutionizing the world of content creation because it removes the limitations that typically restrict our creative ideas.</p>
            <p className="text-base text-gray-700 mb-4">Swim with sharks. Travel to outer space. Cast a spell as a wizard.</p>
            <p className="text-base text-gray-700 mb-4">It's all possible, thanks to Artificial intelligence.</p>
            <p className="text-base text-gray-700 mb-4"><span><strong>And they REALLY work!</strong></span></p>
            <p className="text-base text-gray-700">The thumbnail below performed extremely well and it was made with AI!</p>
          </div>
        </div>

        {/* Success Example */}
        <div className="max-w-4xl mx-auto mb-12">
          <img 
            src="https://static.readdy.ai/image/1ee33a74a7d817227244af36e3fd2b0e/431faca1d357cd2ed1b60be3d6fd9668.jpeg" 
            alt="Successful AI Thumbnail" 
            className="w-full rounded-lg mb-8"
          />
        </div>

        <div className="grid md:grid-cols-3 gap-8 max-w-5xl mx-auto">
          <div className="md:col-span-2">
            <img 
              src="https://static.readdy.ai/image/1ee33a74a7d817227244af36e3fd2b0e/c71739900a1a7fa3e1a790843e2b69c4.jpeg" 
              alt="AI Thumbnail Success" 
              className="w-full rounded-lg shadow-md"
            />
          </div>
          <div className="bg-white rounded-lg shadow-md p-6">
            <p className="text-base text-gray-700 mb-4"><strong>AI Thumbnails Perform Extremely Well</strong></p>
            <p className="text-base text-gray-700">Some people seem to like the AI version of me more than the real version... 😅</p>
          </div>
        </div>
      </div>
    </section>
  );
}
